import classNames from '../_util/classNames';
function renderExpandIcon(locale) {
    return function expandIcon({ prefixCls, onExpand, record, expanded, expandable, }) {
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return (<button type="button" onClick={e => {
                onExpand(record, e);
                e.stopPropagation();
            }} class={classNames(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded,
            })} aria-label={expanded ? locale.collapse : locale.expand}/>);
    };
}
export default renderExpandIcon;
